module.exports = __webpack_public_path__ + "static/concrete-section-reinforcement-880x880-9ee7e5c0e4984a928d96970cb3249561.png";